import { DiffEditor } from "@monaco-editor/react";
import { get } from "lodash-es";
import React, { FC } from "react";

import { Paper, Stack, Typography } from "@mui/material";

import LoadingScreen from "../../../components/LoadingScreen";
import useMonaco from "../../../hooks/use-monaco";
import { useSettings } from "../../../hooks/use-settings";
import { ActivityLog } from "../../../store/pomeriumApi";

type ActivityLogDiffProps = {
  left?: ActivityLog;
  right?: ActivityLog;
};
const ActivityLogDiff: FC<ActivityLogDiffProps> = ({ left, right }) => {
  const settings = useSettings();

  const getData = (activityLog: ActivityLog): string => {
    return JSON.stringify(activityLog?.entity?.data, null, 2) || "";
  };
  const getTitle = (activityLog: ActivityLog): string => {
    return (
      get(activityLog, "entity.type") +
      (get(activityLog, "entity.data.name")
        ? ":" + get(activityLog, "entity.data.name")
        : "") +
      "@" +
      get(activityLog, "id")
    );
  };

  const { loading, error } = useMonaco();

  if (error) {
    return <div>Failed to initialize editor: {error?.message || error}</div>;
  }

  if (loading) {
    return <LoadingScreen />;
  }

  const leftValue = left ? getData(left) : "";
  const rightValue = right ? getData(right) : "";
  return (
    <Paper sx={{ fontSize: "0.7rem", flexGrow: 1, minHeight: "200px" }}>
      <Stack sx={{ height: "100%" }}>
        <Typography variant="body1" sx={{ p: 1 }}>
          {left ? getTitle(left) : right ? getTitle(right) : ""}
        </Typography>
        <DiffEditor
          height="100%"
          original={leftValue}
          originalLanguage="json"
          modified={rightValue}
          modifiedLanguage="json"
          options={{
            readOnly: true,
            lineNumbers: "off",
            showFoldingControls: "never",
            folding: false,
            renderOverviewRuler: false,
            lineDecorationsWidth: 0,
            lineNumbersMinChars: 0,
            glyphMargin: false,
            scrollbar: {
              vertical: "auto",
            },
            scrollBeyondLastLine: false,
            overviewRulerLanes: 0,
            overviewRulerBorder: false,
          }}
          theme={settings.paletteMode}
        />
      </Stack>
    </Paper>
  );
};

export default ActivityLogDiff;
